// extracted by mini-css-extract-plugin
export var downArrow = "_75-0";
export var label = "_75-1";
export var treatmentCard = "_75-3";
export var upArrow = "_75-2";